export default {
    message: { 
        khmer: "Khmer",
        english: "English",
        // translate home page
        welcome: "Welcome",
        passenger: "Passenger",
        bus: "BUS",
        speedBoat: "SPEED BOAT",
        from: "From",
        to: "To",
        selectDeparture: "Select Departure",
        selectDestination: "Select Destination",
        departureDate: "Departure Date",
        returnDate: "Return Date",
        selectDate: "Choose Date",
        search: "Search",
        noDepartureFound: "No Departure Found",
        noDestinationFound: "No Destination Found",
        home: "Home",
        myBooking: "My Booking",
        information: "Information",
        plSelectDeparture: "Please Select Departure",
        plSelectDestination: "Please Select Destination",
        ok: "OK",
        // translate Ticket booking transaction
        ticketCode: "Ticket Code",
        departureDates: "Departure Date",
        viewDetails: "View Details",
        bookedDate: "Booked Date",
        transType: "Transportation Type",
        seatNumber: "Seat Number",
        ticketPrice: "Ticket Price",
        subTotal: "Subtotal",
        discount: "Discount",
        grandTotal: "Total",
        // translate schedule list
        departureTime: "Departure Time",
        arrivalTime: "Arrival Time",
        remainingSeat: "Remaining Seat",
        seats: "Seats",
        booking: "BOOK",
        leave: "LEAVE",
        sorry: "Sorry !",
        description: "There are no results for this search. Try another destination or departure date.",
        BackToSearch: "Back to Search",
        // translate choose seat
        chooseSeat: "Choose seat",
        free: "Free",
        selected: "Selected",
        noAvailable: "No Available",
        notAvailable: "NOT AVAILABLE",
        warning: "Warning",
        descriptionSeat: "You are required to select seat(s) for every locations with the same amount of seat(s) to continue.",
        descriptionSeatBack: "You cannot select amount of seats that is different your previously selecting.The number of seats you selected is",
        next: "NEXT",
        // translate passenger 
        informationNotEnough: "Information not enough",
        contactInformation: "Contact Information",
        labelName: "Name",
        labelTelephone: "Telephone",
        name: "Enter your name",
        telephone: "Enter your phone",
        selectBoardingPoint: "Select Boarding Point",
        dropOffPoint: "Drop Off Point",
        customerInformation: "Customer Information",
        gender: "Gender",
        national: "Nationality",
        male: "Male",
        female: "Female",
        cambodian: "Cambodian",
        foreigner: "Foreigner",
        processToPayment: "Process to payment",
        alertSeatSelected: "Seat is not available, please chose your trip again.",
        alertWrong: "Something went wrong, Please try it again.",
        // translate Payment 
        boardingPoint: "Boarding Point",
        arrivalDate: "Arrival Date",
        travelTripFrom: "Travel Trip From",
        paymentTime: "Payment Time",
        timeOut: "Complete your payment before timeout",
        roundTripTicket: "Round Trip ticket",
        travelSummary: "Travel Summary",
        total: "Total",
        payNow: "Pay",
        payingWithAccount: "Paying with account",
        vetExpress: "VET EXPRESS",
        ask: "Do you want to cancel booking?",
        no: "No",
        yes: "Yes",
        close: "Close",
        sessionExpired: "Session Expired",
        somethingWentWrong: "Something went wrong",
        pleaseTryItAgain: "Please try it again.",
        paymentNotSuccess: "Payment Not Success",
        alertInsufficientBalance: "Your Account Insufficient Balance",
        paymentSummary: "Payment Summary",
        paymentSession: "Session Timed Out",
        inclVat: "(Incl. VAT)",
        // translate Payment Success
        msgTitle: "Your ticket have booked",
        msg: "Please arrive Departure location before 30mn . Please check information in the ticket booking transaction.",
        showTicket: "Show Ticket",
        // translate internet
        error: "Message",
        msgInternet: "Please check Internet connection",
        exitApp: "Do you want to exit app?",
        exit: "Yes",
        noTripFound: "No Trip Found",
        calendar: "Calendar",
        language: "Language",
    }
}